<template>
  <div ref="input" class="input full">
    <div class="dropdown">
      <v-select
        @input="chooseAnswer"
        :value="answer.label"
        :options="input.dropdown"
        label="title"
        :searchable="false"
        :clearable="false"
      >
        <template v-slot:option="option">
          <b>{{option.label}}</b>
          <br />
          {{option.words}}
        </template>
      </v-select>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import VueSelect from "vue-select";

import "vue-select/dist/vue-select.css";

Vue.component("v-select", VueSelect);

export default {
  name: "DropDown",
  props: ["input", "questionIndex", "answerKey"],

  data() {
    return {
      answer: null
    };
  },
  mounted() {},
  created() {
    this.answer = this.input.value;
    if (this.optional) {
      this.$parent.question = +"(optional)";
    }
  },
  firestore() {
    return {};
  },
  methods: {
    saveAnswer(e) {
      this.$emit(
        "updateAnswer",
        this.questionIndex,
        this.answerKey,
        this.answer
      );
    },
    chooseAnswer(option) {
      console.log(option);
      this.answer = option;
      this.saveAnswer();
    }
  },
  watch: {}
};
</script>

<style scoped lang='scss'>
.dropdown {
  display: flex;
  flex-direction: column;
}
.option {
  width: 100%;
  color: #0b6efb;
  padding: 10px 20px;
  margin-bottom: 10px;
  background-color: white;
  border-radius: 5px;
  cursor: pointer;
  box-shadow: 0px 2px lightgray;
  border: 2px solid transparent;
  transition: border 0.3s;
}
.option.chosen {
  box-shadow: 0px 0px;
  border: 2px solid #0b6efb;
}
</style>
